import React from 'react'
import { FormControlLabel, MenuItem, Select, FormControl, FormHelperText } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import get from 'lodash/get'

/**
 * 
 * @param {*} options [{ value, label }]
 * @returns 
 */
const ItemFormSelect = ({
    name,
    labelKey,
    rules,
    options = [],
    required = false,
    ...props
}) => {
    const { t } = useTranslation()
    const { control, formState: { errors } } = useFormContext()
    const { labelPlacement = "start", onChangeCustom, disabled, readOnly = false } = props

    const error = get(errors, name)

    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            render={({ field }) => (
                <FormControlLabel
                    label={t(labelKey)}
                    labelPlacement={labelPlacement}
                    required={required}
                    control={
                        <FormControl fullWidth error={!!error}>
                            <Select
                                {...field}
                                required={required}
                                disabled={disabled}
                                inputProps={{ readOnly }}
                                onMouseDown={(event) => {
                                    if (readOnly) event.preventDefault();
                                }}
                                onKeyDown={(event) => {
                                    if (readOnly) event.preventDefault();
                                }}
                                sx={{ borderColor: '#8F9294' }}
                                displayEmpty
                                fullWidth
                                onChange={(event) => {
                                    if (readOnly) return;
                                    field.onChange(event);
                                    onChangeCustom?.(event.target.value, event);
                                }}
                            >
                                {options.map((e) => (
                                    <MenuItem key={e.value} value={e.value}>
                                        {e.label}
                                    </MenuItem>
                                ))}
                            </Select>
                            {error && <FormHelperText>{t(error.message)}</FormHelperText>}
                        </FormControl>
                    }
                />
            )}
        />
    )
}

export default ItemFormSelect
